
















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RustCheckoutInfo extends Vue {
  name = 'RustCheckoutInfo';

  multiplier = 2.5;

  @Prop({ type: Number, default: 10 }) readonly slots: number;

  /**
         * returns the title
         */
  getTitle(): string {
    return this.$t('checkout:stepone.game_checkout_info.rust.title');
  }

  /**
   * returns the text for explaining how many slots
   * the customer will get in the end (multiplied)
   */
  getServerSlotInfo(): string {
    return this.$t('checkout:stepone.game_checkout_info.rust.server_info');
  }

  getSlotsPerRustServer(): number {
    return this.multiplier * this.slots;
  }
}
